<zag-card variant="elevated">
  <div card-header class="zag-swap-request-card__header">
    <div class="zag-swap-request-card__type">
      @if (request().type === 'swap') {
      <span zagIcon="swap_horiz" class="zag-swap-request-card__type-icon zag-swap-request-card__type-icon--swap"></span>
      <span class="zag-swap-request-card__type-label">{{ 'shiftSwaps.typeLabelSwap' | translate }}</span>
      } @else {
      <span zagIcon="person_add" class="zag-swap-request-card__type-icon zag-swap-request-card__type-icon--takeover"></span>
      <span class="zag-swap-request-card__type-label">{{ 'shiftSwaps.typeLabelTakeover' | translate }}</span>
      }
    </div>
    <span
      class="zag-swap-request-card__status"
      [class.zag-swap-request-card__status--pending]="request().status === 'pending'"
      [class.zag-swap-request-card__status--pending-planner]="request().status === 'pending_planner_approval'"
      [class.zag-swap-request-card__status--accepted]="request().status === 'accepted'"
      [class.zag-swap-request-card__status--declined]="request().status === 'declined'"
      [class.zag-swap-request-card__status--cancelled]="request().status === 'cancelled'"
      [class.zag-swap-request-card__status--expired]="request().status === 'expired'"
      [class.zag-swap-request-card__status--superseded]="request().status === 'superseded'"
    >
      {{ statusKey() | translate }}
    </span>
  </div>

  <div class="zag-swap-request-card__body">
    <!-- Direction label -->
    <div class="zag-swap-request-card__direction">
      @if (request().viewerRole === 'planner') {
      <span zagIcon="approval" class="zag-swap-request-card__direction-icon"></span>
      <span>{{ directionLabelKey() | translate: { name: request().targetEmployeeName } }}</span>
      } @else if (request().direction === 'incoming') {
      <span zagIcon="call_received" class="zag-swap-request-card__direction-icon"></span>
      <span>{{ directionLabelKey() | translate: { name: request().requesterName } }}</span>
      } @else {
      <span zagIcon="call_made" class="zag-swap-request-card__direction-icon"></span>
      <span>{{ directionLabelKey() | translate: { name: request().targetEmployeeName } }}</span>
      }
    </div>

    <!-- Target shift (the one the requester wants) -->
    <div class="zag-swap-request-card__shift">
      <div class="zag-swap-request-card__shift-label">{{ 'shiftSwaps.targetShift' | translate }}</div>
      <div class="zag-swap-request-card__shift-detail">
        <div class="zag-swap-request-card__shift-bar" [style.background-color]="request().targetShiftColor"></div>
        <div class="zag-swap-request-card__shift-info">
          <span class="zag-swap-request-card__shift-name">{{ request().targetShiftName }}</span>
          <span class="zag-swap-request-card__shift-time">{{ request().targetStartTime }} – {{ request().targetEndTime }}</span>
        </div>
        <div class="zag-swap-request-card__shift-meta">
          <span>{{ request().targetDateLabel }}</span>
          <span>{{ request().targetPlanName }}</span>
        </div>
      </div>
    </div>

    <!-- Offered shift (swap only) -->
    @if (request().type === 'swap' && request().offeredShiftName) {
    <div class="zag-swap-request-card__arrow">
      <span zagIcon="swap_vert"></span>
    </div>
    <div class="zag-swap-request-card__shift">
      <div class="zag-swap-request-card__shift-label">{{ 'shiftSwaps.offeredShift' | translate }}</div>
      <div class="zag-swap-request-card__shift-detail">
        <div class="zag-swap-request-card__shift-bar" [style.background-color]="request().offeredShiftColor"></div>
        <div class="zag-swap-request-card__shift-info">
          <span class="zag-swap-request-card__shift-name">{{ request().offeredShiftName }}</span>
          <span class="zag-swap-request-card__shift-time">{{ request().offeredStartTime }} – {{ request().offeredEndTime }}</span>
        </div>
        <div class="zag-swap-request-card__shift-meta">
          <span>{{ request().offeredDateLabel }}</span>
          <span>{{ request().offeredPlanName }}</span>
        </div>
      </div>
    </div>
    }
  </div>

  @if (isActionable()) {
  <div class="zag-swap-request-card__footer">
    <span class="zag-swap-request-card__created">{{ request().createdAtLabel }}</span>
    <div class="zag-swap-request-card__actions">
      @if (canApprove() || request().direction === 'incoming') {
      <button zagButton size="sm" variant="outlined" [disabled]="actionInProgress()" (click)="onDecline($event)">
        <span zagIcon="close"></span>
        {{ 'shiftSwaps.decline' | translate }}
      </button>
      <button zagButton size="sm" [disabled]="actionInProgress()" (click)="onAccept($event)">
        @if (actionInProgress()) {
        <span zagIcon="sync" class="zag-swap-request-card__spinner"></span>
        } @else {
        <span zagIcon="check"></span>
        } {{ (canApprove() ? 'shiftSwaps.approve' : 'shiftSwaps.accept') | translate }}
      </button>
      } @else {
      <button zagButton="outlined" zagType="secondary" zagSize="sm" [disabled]="actionInProgress()" (click)="onCancel($event)">
        <span zagIcon="close"></span>
        {{ 'shiftSwaps.cancelRequest' | translate }}
      </button>
      }
    </div>
  </div>
  }
</zag-card>
